import { types } from "mobx-state-tree"

export const DoctorWorkingHour = types
    .model({
        id: types.maybeNull(types.optional(types.number, 0)),
        start: types.maybeNull(types.optional(types.string, "")),
        end: types.maybeNull(types.optional(types.string, ""))
    }).actions(self => ({

    }))